(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-bundle-product-builder"] && !Shopify.designMode) return;
  try {
    class ProductBuilder extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.mainBundleProductVariantId = this.querySelector('#main-bundle-product-variant-id').value;
      this.atc = this.querySelector('#pdp-bundle-product-builder--atc');
      this.builderItems = Array.from(this.querySelectorAll('pdp-bundle-product-builder-item'));
      this.error = this.querySelector('#pdp-bundle-product-builder--error-message');

      // this.addEventListener('change', () => {
      //   this.validateBundle();
      // });
      this.atc?.addEventListener('click', this.addToCartEventHandler.bind(this));
    }

    disconnectedCallback() {
      // this.removeEventListener('change', () => {
      //   this.validateBundle();
      // });
      this.atc.removeEventListener('click', this.addToCartEventHandler.bind(this));
    }

    addToCartEventHandler() {
      // const isValidBundle = this.validateBundle();
      // if (!isValidBundle) return;
      this.addToCart();
    }

    validateBundle() {
      const selectedVariantsId = this.builderItems.map(
        (item) => item.querySelector(`#pdp-bundle-product-builder-item--selector`).value
      );
      const defaultVariantId = selectedVariantsId[0];
      if (selectedVariantsId.every((item) => item === defaultVariantId)) {
        this.showError(true);
        this.disableAddToCartBtn(true);
        return false;
      } else {
        this.showError();
        this.disableAddToCartBtn();
        return true;
      }
    }

    showError(flag = false) {
      this.error.classList[flag ? 'remove' : 'add']('pdp-bundle-product-builder--hide-error');
    }

    disableAddToCartBtn(flag = false) {
      this.atc.disabled = flag;
    }

    async addToCart() {
      const formData = {
        items: [
          {
            id: this.mainBundleProductVariantId,
            quantity: 1,
            properties: {
              _bundle_name: 'build_your_own_bundle',
              _bundle_timestamp: Date.now(),
              ...this.bundleItemsObjects(),
              _bundle_product_builder: this.bundleItemsTitles(),
            },
          },
        ],
      };

      try {
        this.disableAddToCartBtn(true);
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
      } catch (error) {
        console.log(`❌ pdp-bundle-product-builder | ${error}`);
      } finally {
        this.disableAddToCartBtn(false);
      }
    }

    bundleItemsObjects() {
      return Object.fromEntries(
        this.builderItems.map((item, index) => {
          const variantId = item.querySelector('#pdp-bundle-product-builder-item--selector').value;
          return [`_bundle_item_${index + 1}`, `gid://shopify/ProductVariant/${variantId}`];
        })
      );
    }

    bundleItemsTitles() {
      return this.builderItems.map((item, index) => {
        const value = item.querySelector('#pdp-bundle-product-builder-item--selector').value;
        const option = item.querySelector(`#pdp-bundle-product-builder-item--selector option[value="${value}"]`);
        return `${option.dataset.cartVariantTitle}`;
      });
    }
  }
  customElements.define('pdp-bundle-product-builder', ProductBuilder);

  class ProductBuilderItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.image = this.querySelector('#pdp-bundle-product-builder-item--img');
      this.productTitle = this.querySelector('#pdp-bundle-product-builder-item---product-title');
      this.selector = this.querySelector('#pdp-bundle-product-builder-item--selector');

      this.selector.addEventListener('change', this.selectorChangeEventHandler.bind(this));
    }

    disconnectedCallback() {
      this.selector.removeEventListener('change', this.selectorChangeEventHandler.bind(this));
    }

    selectorChangeEventHandler(event) {
      const option = event.target.querySelector('option:checked');
      const { variantParentProductTitle, variantFeaturedImage } = option.dataset;
      this.productTitle.innerHTML = variantParentProductTitle;
      this.image.setAttribute('src', variantFeaturedImage);
    }
  }
  customElements.define('pdp-bundle-product-builder-item', ProductBuilderItem);
  } catch(e) { console.error(e); }
})();

})();
